import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { ModalInfoBlockWithTitle } from 'shared/ui/Modal/ui/ModalInfoBlockWithTitle/ModalInfoBlockWithTitle'

import { type IResponseExternalWebhook } from 'entities/Webhook'
import { ModalSelectedWebhook } from 'pages/settings/pages/integrations/pages/Webhooks/ui/ModalSelectedWebhook/ModalSelectedWebhook'
import { WebhookStatus } from 'pages/settings/pages/integrations/pages/Webhooks/ui/WebhookStatus/WebhookStatus'
import styles from './styles.module.scss'

type IDetailsModalProps = {
  webhook: IResponseExternalWebhook
}

const titleMapping = {
  message: 'Messages',
  inbox: 'Inboxes',
  contact: 'Contacts',
  number: 'Numbers',
  member: 'Members',
  conversation: 'Conversations',
  call: 'Calls',
}

export const DetailsModal = observer(({ webhook }: IDetailsModalProps) => {
  const lines = [
    {
      label: 'URL',
      value: webhook.url,
    },
    {
      label: 'Event throttling',
      value: `${webhook.throttle_limit} per second`,
    },
  ]

  const selectedWebhooksLines = webhook.events.reduce((acc, event) => {
    const [prefix] = event.split('.')
    const existingGroup = acc.find((group) => group.title === prefix)

    if (existingGroup) {
      existingGroup.lines.push(event)
    } else {
      acc.push({
        title: prefix,
        lines: [event],
      })
    }

    return acc
  }, [] as Array<{ title: string; lines: string[] }>)

  return (
    <div className={styles.wrap}>
      <div className={styles.titleWrap}>
        <Typography
          tag={'div'}
          ariaLabel={'detailsWebhookName'}
          variant={'heading-lg'}
          tooltipProps={{
            label: webhook.name,
          }}
          ellipsis
        >
          {webhook.name}
        </Typography>
        <WebhookStatus isActive={webhook.is_active} />
      </div>

      <ModalInfoBlockWithTitle title='General' lines={lines} />

      <Typography
        tag='div'
        ariaLabel='SelectedWebhooks'
        variant='body-rg-medium'
        color='var(--content-primary-primary)'
        marginTop={32}
        marginBottom={20}
      >
        Selected webhooks
      </Typography>

      {selectedWebhooksLines.map((block) => (
        <ModalSelectedWebhook
          key={block.title}
          title={titleMapping[block.title as keyof typeof titleMapping]}
          lines={block.lines}
        />
      ))}
    </div>
  )
})
